<template>
  <BaseFrame
    :id="id"
    :idText='idText'
    submitText="提交"
    @submit='thirdPartyValiade()'
    :clearText="deleteText"
    @clear="deleteItem"
    @cancel='$router.push(-1)'
  >
    <div slot="content">
      <lk-card>
        <lk-form
          :rules='formValidate'
          :model='formData'
          :label-width='80'
          label-position='right'
          ref="thirdPartyForm"
        >
          <lk-form-item label="三方平台:" prop='type'>
            <lk-row :gutter='16'>
              <lk-col span="6">
                <lk-select v-model="formData.type">
                  <lk-option v-for="(item,i) in thirdPartyList" :key="i" :value='item.type'>{{item.name}}</lk-option>
                </lk-select>
              </lk-col>
            </lk-row>
          </lk-form-item>
          <lk-form-item label="sku名称:" prop='skuName'>
            <lk-row :gutter='16'>
              <lk-col span="6">
                <lk-input placeholder='请输入sku名称' :maxlength='100' v-model="formData.skuName"></lk-input>
              </lk-col>
            </lk-row>
          </lk-form-item>
          <lk-form-item label="商品信息:" class="ivu-form-item-required">
            <lk-row :gutter='16'>
              <lk-col span="6">
                <inputSearch
                  @selected='addGoods'
                  :loading='goodsloading'
                  @getData='handleInputSearch'
                  :placeHolder='placeholder'
                  :autoFocus='true'
                  :selectedList='drugTableData'
                  :data='goodsData'
                  :columns='goodsColumns'
                >
                </inputSearch>
              </lk-col>
            </lk-row>
          </lk-form-item>
          <lk-form-item :label-width='20'>
            <lk-row>
              <lk-col span="25">
                <lk-table
                  border
                  :columns='drugColumns'
                  :data='drugTableData'
                />
              </lk-col>
            </lk-row>
          </lk-form-item>
        </lk-form>
      </lk-card>
    </div>
  </BaseFrame>
</template>
<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import utils from '@/libs/utils';
import thirdPartyService from '@/services/thirdParty';
import InputSearch from '@/components/InputSearch.vue';
import DtpInputNumber from '@/components/DtpInputNumber.vue';
import queryMixins from '@/mixins/queryMixins';


export default {
  name: 'thirdPartyAdd',
  mixins: [queryMixins],
  components: {
    BaseFrame,
    InputSearch,
  },
  props: {},
  data() {
    return {
      deleteText: '',
      formValidate: {
        type: [
          {
            required: true, message: '请选择三方平台', trigger: 'change', type: 'number',
          },
        ],
        skuName: [
          {
            required: true, message: '请输入sku名称', trigger: 'blur',
          },
        ],
      },
      formData: {
        type: 1, // 暂时只有天猫,默认不让改
      },
      idText: '',
      id: '',
      placeholder: '请输入商品名、通用名或商品编码',
      goodsData: [], // 搜索药品list
      goodsloading: false,
      EDIT: 2, // params.operateType
      goodsColumns: [
        { title: '商品编码', key: 'serialCode', width: '65px' },
        { title: '药品通用名', key: 'approvedDrugNames', width: '142px' },
        { title: '商品名', key: 'goodsName', width: '90px' },
      ],
      drugTableData: [],
      drugColumns: [
        {
          title: '序号',
          minWidth: 116,
          align: 'center',
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '基础商品编码',
          minWidth: 116,
          align: 'center',
          key: 'serialCode',
        },
        {
          title: '通用名称',
          minWidth: 116,
          align: 'center',
          key: 'approvedDrugNames',
        },
        {
          title: '商品名称',
          minWidth: 116,
          align: 'center',
          key: 'goodsName',
        },
        {
          title: '生产企业',
          minWidth: 116,
          key: 'manufacturer',
        },
        {
          title: '包装规格',
          minWidth: 116,
          key: 'specifications',
        },
        {
          title: 'erp销售价格',
          minWidth: 100,
          key: 'price',
          fixed: 'right',
        },
        {
          title: '数量转换系数',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.onNumMountInput(params.index, value);
              },
            },
            props: {
              value: params.row.num,
              min: 0,
              precision: 0,
              ifNeedCheckAllNumber: true,
              frontDecimal: 7,
            },
          }),
        },
        {
          title: '三方销售单价',
          minWidth: 120,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.onPriceMountInput(params.index, value);
              },
            },
            props: {
              value: params.row.skuPrice,
              min: 0,
              precision: 2,
              ifNeedCheckAllNumber: true,
              frontDecimal: 7,
            },
          }),
        },
        {
          title: '操作',
          minWidth: 116,
          fixed: 'right',
          align: 'center',
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.drugTableData.splice(index, 1);
              },
            },
          }, '删除'),
        },
      ],
    };
  },
  watch: {},
  computed: {
    thirdPartyList() {
      return this.$store.state.publicParams.thirdParty;
    },
  },
  methods: {
    onNumMountInput(index, value) {
      const item = this.drugTableData[index];
      item.num = value;
    },
    onPriceMountInput(index, value) {
      const item = this.drugTableData[index];
      item.skuPrice = value;
    },
    thirdPartyValiade() {
      if (!this.drugTableData.length) {
        this.$Message.warning('请选择商品');
        return;
      }
      this.$refs.thirdPartyForm.validate((valid) => {
        valid && this.submit();
      });
    },
    submit() {
      const goods = [];
      this.drugTableData.forEach((item) => {
        const tempG = {
          goodsBaseId: item.goodsBaseId,
          serialCode: item.serialCode,
          num: item.num,
          skuPrice: item.skuPrice,
        };
        if (this.isEdit) {
          tempG.itemId = item.itemId;
        }
        goods.push(tempG);
      });
      const haveZero = goods.filter(item => item.skuPrice <= 0).length > 0;
      if (haveZero) {
        this.$Message.error('三方销售单价不能为0');
        return;
      }
      const haveNumZero = goods.filter(item => item.num <= 0).length > 0;
      if (haveNumZero) {
        this.$Message.error('数量转换系数不能为0');
        return;
      }
      const { id } = this.$route.params;
      const params = {
        skuDetails: goods,
        ...this.formData,
      };
      if (this.isEdit) {
        params.skuId = parseInt(id);
      }
      const finalSubmit = this.isEdit
        ? thirdPartyService.thirdPartyEdit
        : thirdPartyService.thirdPartySubmit;
      finalSubmit(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addGoods(val) {
      if (!val.num) {
        val.num = 1;
      }
      if (!val.skuPrice) {
        val.skuPrice = 1;
      }
      this.drugTableData.push(val);
    },
    handleInputSearch(val) {
      this.goodsloading = true;
      this.goodsData = [];
      thirdPartyService.getGoodsInfo({
        nameMix: val,
      }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data.length) {
            const tempList = res.data.data.filter((item) => {
              return this.drugTableData.filter(item2 => item2.goodsBaseId === item.goodsBaseId).length <= 0;
            });
            this.goodsData = tempList;
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.goodsloading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.goodsloading = false;
      });
    },
    getDetail() {
      thirdPartyService.getThirdPartyInfo({ skuId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          const {
            skuName,
            type,
          } = res.data.data;
          this.formData = {
            type,
            skuName,
          };
          this.drugTableData = res.data.data.skuDetails;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    deleteItem() {
      thirdPartyService.deleteThirdPartyGoods({ skuId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('删除成功');
          this.$router.go(-1);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.isEdit = this.$route.params.operateType == this.EDIT;
    if (this.isEdit) {
      this.getDetail();
    }
    this.deleteText = this.handlePermission('thirdPartyDel') && this.isEdit?'删除': '';
  },
  created() {
  },
};
</script>
<style lang="less" scoped>

</style>
